import { handleRequest } from "../utilities/requestHandler";

export const getOrdersBySite = (req_body) =>
    handleRequest("post","/orders/getOrdersBySite",req_body);

export const getCombinedOrdersBySite = (req_body) =>
    handleRequest("post","/orders/getCombinedOrdersBySite",req_body);

export const getOrderSchedules = (site_id) =>
    handleRequest("post","/orders/getOrderSchedules",{
        site_id: site_id,
    });

export const deleteOrderSchedule = (scheduleId) =>
    handleRequest("post","/orders/scheduleDelete",{
        id: scheduleId,
    });

export const getOrderTrackingDetails = (req_body) =>
    handleRequest("post","/orders/trackOrder",req_body);
